
const RatingForm = () => {
  return (
    <div>RatingForm</div>
  )
}

export default RatingForm